import React from 'react';

import classnames from 'classnames';
import { AlertCircle, PauseCircle, Zap } from 'lucide-react';

import styles from 'css-module/components/subdomain/admin/AdminQueue/_AdminQueueAlert.module.scss';

type Props = {
  type: AlertTypes;
  actions: React.ReactNode;
  text: React.ReactNode;
};

export enum AlertTypes {
  error = 'error',
  paused = 'paused',
  tip = 'tip',
  warning = 'warning',
}

const AlertModes: Record<AlertTypes, { icon: React.ElementType }> = {
  [AlertTypes.error]: {
    icon: () => (
      <div className={classnames(styles.badgeContainer, styles.error)}>
        <AlertCircle height={28} width={28} className={styles.badgeIcon} />
      </div>
    ),
  },
  [AlertTypes.paused]: {
    icon: () => (
      <div className={classnames(styles.badgeContainer, styles.paused)}>
        <PauseCircle height={28} width={28} className={styles.badgeIcon} />
      </div>
    ),
  },
  [AlertTypes.tip]: {
    icon: () => (
      <div className={classnames(styles.badgeContainer, styles.tip)}>
        <Zap height={18} width={18} className={styles.badgeIcon} />
      </div>
    ),
  },
  [AlertTypes.warning]: {
    icon: () => (
      <div className={classnames(styles.badgeContainer, styles.warning)}>
        <AlertCircle height={28} width={28} className={styles.badgeIcon} />
      </div>
    ),
  },
};

const AdminQueueAlert = ({ type, actions, text }: Props) => {
  const { icon: Icon } = AlertModes[type];
  return (
    <div className={styles.adminQueueAlert}>
      <div className={styles.left}>
        <Icon />
        <div className={styles.text}>{text}</div>
      </div>
      <div className={styles.actions}>{actions}</div>
    </div>
  );
};

export default AdminQueueAlert;
